import { render, staticRenderFns } from "./DataSourceSelect.vue?vue&type=template&id=126bfa7d"
import script from "./DataSourceSelect.vue?vue&type=script&lang=js"
export * from "./DataSourceSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports